import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-schedule',
  templateUrl: './shipping-schedule.component.html',
  styleUrls: ['./shipping-schedule.component.scss']
})
export class ShippingScheduleComponent {

}
